export default {
  'pages.common.save': 'Salvar',
  'pages.common.cancel': 'Cancelar',
  'pages.common.confirm': 'OK',
  'pages.common.ok': 'OK',
  'pages.common.delete': 'Excluir',
  'pages.common.edit': 'Editar',
  'pages.common.add': 'Adicionar',
  'pages.common.append': 'Adicionar',
  'pages.common.search': 'Pesquisar',
  'pages.common.reset': 'Redefinir',
  'pages.common.submit': 'Enviar',
  'pages.common.back': 'Voltar',
  'pages.common.close': 'Fechar',
  'pages.common.export': 'Exportar',
  'pages.common.import': 'Importar',
  'pages.common.refresh': 'Atualizar',
  'pages.common.detail': 'Detalhes',
  'pages.common.copy': 'Copiar',
  'pages.common.operation': 'Ações',
  'pages.common.view': 'Ver',
  'pages.common.download': 'Baixar',
  'pages.common.upload': 'Enviar arquivo',
  'pages.common.yes': 'Sim',
  'pages.common.no': 'Não',
  'pages.common.loading': 'Carregando…',
  'pages.common.more': 'Mais',
  'pages.common.all': 'Todos',
  'pages.common.createSuccess': 'Criado com sucesso',
  'pages.common.saveSuccess': 'Salvo',
  'pages.common.deleteSuccess': 'Excluído',
  'pages.common.deleteFailed': 'Falha ao excluir',
  'pages.common.saveFailed': 'Falha ao salvar',
  'pages.common.loadFailed': 'Falha ao carregar',
  'pages.common.requiredField': 'Campo obrigatório',
  'pages.common.selectedCount': '{count} item(ns) selecionado(s)',
  'pages.common.clearSelection': 'Limpar seleção',
  'pages.common.totalRecords': '{total} registros no total',
  'pages.common.batchDeleteCount': 'Exclusão em lote ({count})',
  'pages.common.statusSuccess': 'Sucesso',
  'pages.common.statusFailed': 'Falha',
  'pages.common.timeRangeStart': 'Hora inicial',
  'pages.common.timeRangeEnd': 'Hora final',
  'pages.common.unnamed': 'Sem nome',
  'pages.common.operationFailedRetry': 'Falha na operação. Tente novamente.',
  'pages.common.batchDeleteSuccess': 'Exclusão em lote concluída',
  'pages.common.batchDeleteFailed': 'Falha na exclusão em lote. Tente novamente.',
  'pages.common.nItemsFailed': '{count} item(ns) falharam',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
